import { Component, OnInit, Injector, Inject } from '@angular/core';
import { SeoAwareBaseComponent } from './../common-theme/seo/seo-aware-base.component';
import { Lightbox, LightboxConfig } from 'angular2-lightbox';
import { ListTrackingService } from '../common-theme/utils/list-tracking.service';

@Component({
  selector: 'app-gallery-page',
  templateUrl: './gallery-page.component.html',
  styleUrls: ['./gallery-page.component.scss']
})

export class GalleryPageComponent extends SeoAwareBaseComponent implements OnInit {
  public officeImages: any[] = [
    { url: '/assets/images/gallery/office/1.jpeg' },
    { url: '/assets/images/gallery/office/2.jpeg' },
    { url: '/assets/images/gallery/office/3.jpeg' }
  ];
  public exteriorImages: any[] = [
    { url: '/assets/images/gallery/exterior/1.jpg' },
    { url: '/assets/images/gallery/exterior/2.jpg' },
    { url: '/assets/images/gallery/exterior/3.jpg' },
    { url: '/assets/images/gallery/exterior/4.jpg' },
    { url: '/assets/images/gallery/exterior/5.jpg' },
    { url: '/assets/images/gallery/exterior/6.jpg' },
    { url: '/assets/images/gallery/exterior/7.jpg' }
  ];
  public furnishedImages: any[] = [
    { url: '/assets/images/gallery/furnished/1.jpg' },
    { url: '/assets/images/gallery/furnished/2.jpg' },
    { url: '/assets/images/gallery/furnished/3.jpg' },
    { url: '/assets/images/gallery/furnished/4.jpg' },
    { url: '/assets/images/gallery/furnished/5.jpg' },
    { url: '/assets/images/gallery/furnished/6.jpg' },
    { url: '/assets/images/gallery/furnished/7.jpg' },
    { url: '/assets/images/gallery/furnished/8.jpg' },
    { url: '/assets/images/gallery/furnished/9.jpg' },
    { url: '/assets/images/gallery/furnished/10.jpg' },
    { url: '/assets/images/gallery/furnished/11.jpg' },
    { url: '/assets/images/gallery/furnished/12.jpg' },
    { url: '/assets/images/gallery/furnished/13.jpg' },
    { url: '/assets/images/gallery/furnished/14.jpg' },
    { url: '/assets/images/gallery/furnished/15.jpg' },
    { url: '/assets/images/gallery/furnished/16.jpg' },
    { url: '/assets/images/gallery/furnished/17.jpg' },
    { url: '/assets/images/gallery/furnished/18.jpg' },
    { url: '/assets/images/gallery/furnished/19.jpg' }
  ];
  public interiorImages: any[] = [
    { url: '/assets/images/gallery/interior/1.jpg' },
    { url: '/assets/images/gallery/interior/2.jpg' },
    { url: '/assets/images/gallery/interior/3.jpg' },
    { url: '/assets/images/gallery/interior/4.jpg' },
    { url: '/assets/images/gallery/interior/5.jpg' },
    { url: '/assets/images/gallery/interior/6.jpg' },
    { url: '/assets/images/gallery/interior/7.jpg' },
    { url: '/assets/images/gallery/interior/8.jpg' },
    { url: '/assets/images/gallery/interior/9.jpg' },
    { url: '/assets/images/gallery/interior/10.jpg' },
    { url: '/assets/images/gallery/interior/11.jpg' },
    { url: '/assets/images/gallery/interior/12.jpg' },
    { url: '/assets/images/gallery/interior/13.jpg' },
    { url: '/assets/images/gallery/interior/14.jpg' },
    { url: '/assets/images/gallery/interior/15.jpg' },
    { url: '/assets/images/gallery/interior/16.jpg' }
  ];

  constructor(
    public injector: Injector,
    private _lightbox: Lightbox,
    public listTrackingService: ListTrackingService,
    private _lighboxConfig: LightboxConfig,
    @Inject('WINDOW') private window: any
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.setTitle('Galerie foto Dream Residence - randari exterior si imagini interior.');
    this.setMetaDescription(`
      Iata cateva imagini care iti arata cat de frumos va fi sa locuiesti - pentru ca e intotdeauna minunat sa fii aproape de natura. Complex rezidential de calitate.
    `);
  }

  public open(images: any[], index: number, event: any): void {
    if (event)
      event.stopPropagation();

    if (this.window)
      this._lighboxConfig.positionFromTop = 20;

    const albums = [];

    for (const image of images) {
      const album = {
        src: image.url,
        thumb: image.url
      };

      albums.push(album);
    }

    this._lightbox.open(albums, index, { wrapAround: true, showImageNumberLabel: true });
  }

  public isMobileSafari() {
    const is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent);
    const is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

    return is_ios && is_safari;
  }
}



// WEBPACK FOOTER //
// ./src/app/gallery-page/gallery-page.component.ts